import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Targeting = forwardRef<SVGSVGElement | null, IconFilledProps>(function Targeting({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12ZM12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.75 2.5C12.75 2.22386 12.5261 2 12.25 2H11.75C11.4739 2 11.25 2.22386 11.25 2.5V4.28582C7.5685 4.63935 4.63935 7.5685 4.28582 11.25H2.5C2.22386 11.25 2 11.4739 2 11.75V12.25C2 12.5261 2.22386 12.75 2.5 12.75H4.28582C4.63935 16.4315 7.5685 19.3607 11.25 19.7142V21.5C11.25 21.7761 11.4739 22 11.75 22H12.25C12.5261 22 12.75 21.7761 12.75 21.5V19.7142C16.4315 19.3607 19.3607 16.4315 19.7142 12.75H21.5C21.7761 12.75 22 12.5261 22 12.25V11.75C22 11.4739 21.7761 11.25 21.5 11.25H19.7142C19.3607 7.5685 16.4315 4.63935 12.75 4.28582V2.5ZM18 11.25H18.2055C17.8644 8.39773 15.6023 6.13565 12.75 5.79454V6C12.75 6.27614 12.5261 6.5 12.25 6.5H11.75C11.4739 6.5 11.25 6.27614 11.25 6V5.79454C8.39773 6.13565 6.13565 8.39773 5.79454 11.25H6C6.27614 11.25 6.5 11.4739 6.5 11.75V12.25C6.5 12.5261 6.27614 12.75 6 12.75H5.79454C6.13565 15.6023 8.39773 17.8644 11.25 18.2055V18C11.25 17.7239 11.4739 17.5 11.75 17.5H12.25C12.5261 17.5 12.75 17.7239 12.75 18V18.2055C15.6023 17.8644 17.8644 15.6023 18.2055 12.75H18C17.7239 12.75 17.5 12.5261 17.5 12.25V11.75C17.5 11.4739 17.7239 11.25 18 11.25Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.25 2C12.5261 2 12.75 2.22386 12.75 2.5V4.28582C16.4315 4.63935 19.3607 7.5685 19.7142 11.25H21.5C21.7761 11.25 22 11.4739 22 11.75V12.25C22 12.5261 21.7761 12.75 21.5 12.75H19.7142C19.3607 16.4315 16.4315 19.3607 12.75 19.7142V21.5C12.75 21.7761 12.5261 22 12.25 22H11.75C11.4739 22 11.25 21.7761 11.25 21.5V19.7142C7.5685 19.3607 4.63935 16.4315 4.28582 12.75H2.5C2.22386 12.75 2 12.5261 2 12.25V11.75C2 11.4739 2.22386 11.25 2.5 11.25H4.28582C4.63935 7.5685 7.5685 4.63935 11.25 4.28582V2.5C11.25 2.22386 11.4739 2 11.75 2H12.25ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'targeting-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Targeting;
